import { render, staticRenderFns } from "./RFPProjectInformation.vue?vue&type=template&id=8b601ca4"
import script from "./RFPProjectInformation.vue?vue&type=script&lang=js"
export * from "./RFPProjectInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports